import LoadingScreen from "minimals-template/components/LoadingScreen"
import { NoResultsContainer } from "lib/@components/no-results/no-results"
import { useParams } from "react-router"
import { useProject } from "authoring/lib/hooks/use-project"

export function GroupRouteBoundary({ children }) {
    const { projectId, groupId } = useParams()
    const { loading, project } = useProject({ id: projectId })
    const group = project?.groups?.find(({ id }) => id === groupId)

    if (loading) return <LoadingScreen />
    if (!group) return <NoResultsContainer title="Group unavailable" message="This group is currently unavailable." />

    return children
}
